const year = new Date().getFullYear();
module.exports = {
  footerText: `© Copyright ${year} Caregility`,
};
